import Vue from 'vue'
import VeeValidate from 'vee-validate';


// Apply validation
Vue.use(VeeValidate, {
    locale: 'en',
});
